import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
//// default vue code
//import App from './App.vue'

// https://stackoverflow.com/questions/43208012/how-do-i-format-currencies-in-a-vue-component
Vue.use(Vue2Filters)
Vue.config.productionTip = false


//// default vue code
//new Vue({
//  render: h => h(App),
//}).$mount('#app')

// register components
Vue.component('users-grid', require('./components/UsersGrid.vue').default);
Vue.component('weather-forecast', require('./components/WeatherForecast.vue').default);
Vue.component('collection-list', require('./components/Collection.vue').default);

window.Vue = Vue;